<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="default" color="#7bff76" type="square-loader" [fullScreen]="false">
    <p style="color: white"> Loading... </p>
</ngx-spinner>
<div class="content-wrapper">
    <div class="card ">
        <div class="card-header bg-primary">
            <div class="row" style="float: left;">
                <h2><i class="fas fa-search"></i> สืบค้นข้อมูลการส่งอ้อย </h2>
            </div>
        </div>
        <div class="card-body">
            <form [formGroup]="Perday">
                <!--<div class="input-group mb-3">
                    <span class="input-group-text" id="basic-addon2">กรุณาเลือกปี</span>
                    <select class="form-select" formControlName="syear">
                        <option value="6364">63/64</option>
                        <option value="6465">64/65</option>
                        <option selected value="6566">65/66</option>
                    </select>
                </div>
                -->
                <div class="row no-print">
                    <div class="col-12">
                        <div class="row justify-content-md-center">
                            <div class="col-md-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>1.กรุณาเลือกปี</mat-label>
                                    <mat-select disableRipple required formControlName="syear">
                                        <mat-option [value]="6364">-- ปี63/64 --</mat-option>
                                        <mat-option [value]="6465">-- ปี64/65 --</mat-option>
                                        <mat-option [value]="6566">-- ปี65/66 --</mat-option>
                                        <mat-option [value]="6667">-- ปี66/67 --</mat-option>
                                        <mat-option [value]="6768">-- ปี67/68 --</mat-option>
                                        <mat-option [value]="6869" selected>-- ปี 68/69 --</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>2.เลือกเงื่อนไข</mat-label>
                                    <mat-select matNativeControl formControlName="condistion">
                                        <mat-option value="1">ตามบัญชีชาวไร่</mat-option>
                                        <mat-option value="2">ตามทะเบียนรถบรรทุก</mat-option>
                                        <mat-option value="3">ตามรหัสรถตัด</mat-option>
                                        <mat-option value="4">ตามรหัสรถคีบ</mat-option>
                                        <mat-option value="5">ตามกลุ่มตัด</mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-md-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>3.เลือกสิ่งที่ต้องการค้นหา</mat-label>
                                    <input matInput formControlName="wannafind" placeholder="คำค้นหา">
                                </mat-form-field>
                            </div>
                            <div class="col-md-auto">
                                <mat-form-field appearance="fill">
                                    <mat-label>4.ช่วงวันที่จะค้นหา</mat-label>
                                    <mat-date-range-input [rangePicker]="picker" disabled>
                                        <input matStartDate formControlName="firstday" placeholder="วันที่เริ่มต้น">
                                        <input matEndDate formControlName="lastday" placeholder="วันที่สุดท้าย">
                                    </mat-date-range-input>

                                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                    <mat-date-range-picker #picker disabled="false"></mat-date-range-picker>
                                </mat-form-field>
                            </div>
                            <div class="col-md-auto">
                                <div class="example-button-row">
                                    <button mat-raised-button color="primary" (click)="Loaddatadaytoday();"><i
                                            class="fas fa-check"></i>ตกลง</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>

            <!-- วันที่ เลขใบคิว ชื่อ ประเภทอ้อยสด/ไฟ ทะเบียน น้ำหนัก ซีซีเอส เลขแปลง รอบ คิว  เติมน้ำมัน ประมาณค่าอ้อย ค่าน้ำมัน
                  แล้วก็ รวมไว้ที่ด้านล่างด้วยนะ พวกคอลัมน์  -->
            <hr>
            <div class="row" *ngIf="dataintable.length>0">
                <div class="col"></div>
                <div class="col-md-3">
                    <button class="btn btn-sm btn-primary" (click)="ExportExcel();"> <i class="fas fa-download"></i>
                        ออกรายงาน</button>
                </div>
                <div class="col-md-3" style="text-align:center">
                    <h3> วันที่: {{Perday.get('firstday').value | adtob}} - {{Perday.get('lastday').value | adtob}}</h3>
                </div>
                <div class="col-md-3" style="text-align:right">
                    <button mat-raised-button color="accent" (click)="printPage()"><mat-icon> print </mat-icon></button>
                </div>
                <div class="col"></div>
            </div>
            <table #table class="table table-sm table-striped table-hover table-head-fixed table-bordered text-nowrap"
                style="text-align:center">
                <thead>
                    <tr class="headText text-primary text-left">
                        <th>.</th>
                        <th>วันที่</th>
                        <th>เลขใบคิว</th>
                        <th>หมายเลขแปลง</th>
                        <th>ชื่อ - สกุล</th>
                        <th>อ้อยสด/ไฟ</th>
                        <th>ทะเบียน</th>
                        <th>กลุ่มตัด</th>
                        <th>รถตัด/รถคีบ</th>
                        <th>คิว</th>
                        <th>รอบ</th>
                        <th>น้ำหนัก</th>
                        <th>CCS</th>
                        <th>เติมน้ำมัน</th>
                        <th>ค่าน้ำมัน</th>
                        <th>ประมาณค่าอ้อย</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of dataintable; let i = index;" style="text-align:center">
                        <td>{{i+1}}</td>
                        <td>{{(item.reportdate)|date:'YYYY/MM/dd'}}</td>
                        <td>{{(item.truck_q).toString()}}</td>
                        <td>{{item.landno}}</td>
                        <td class="text-left">{{item.fmname}}</td>
                        <td>
                            <label *ngIf="item.cane_type==1">อ้อยสด</label>
                            <label *ngIf="item.cane_type==2">อ้อยไฟ</label>
                        </td>
                        <td class="text-left">{{item.REGTRUCK}}</td>
                        <td>{{item.groupcode}}</td>
                        <td>{{item.cut_no}}{{item.keep_no}}</td>

                        <td>{{item.q_id}}</td>
                        <td>{{item.ref_doc1}}</td>
                        <td class="text-right">{{item.wgt_net}}</td>
                        <td class="text-right">{{item.ccs_value}}</td>
                        <td class="text-right">{{item.oil_litre}}</td>
                        <td class="text-right">{{item.oil_amount | number}}</td>
                        <td class="text-right">{{item.cane_amt | number}}</td>
                    </tr>
                </tbody>
                <tfoot>
                    <tr class="table-success under" *ngFor="let item of sumdataintable">
                        <td [colSpan]="9"></td>
                        <td>++ รวม ++</td>
                        <td></td>
                        <td class="text-right">{{item.sumweight | number}}</td>
                        <td class="text-right">{{item.sumccs | number}}</td>
                        <td class="text-right">{{item.sumfillgas | number}}</td>
                        <td class="text-right">{{item.sumfillprice | number}}</td>
                        <td class="text-right">{{item.sumsugarcaneprice | number}}</td>
                    </tr>
                </tfoot>
            </table>
        </div>
    </div>
</div>
<app-footer></app-footer>
